import React, { useState } from 'react';
import api from '@/lib/api';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { PaperPlaneTilt, ShieldCheck, CheckCircle } from '@phosphor-icons/react';
import TanowMark from '@/components/TanowMark';
import { toast } from 'sonner';

export default function Footer() {
    const [email, setEmail] = useState('');
    const [done, setDone] = useState(false);
    const [busy, setBusy] = useState(false);
    const submit = async (e) => {
        e?.preventDefault();
        if (!email.trim()) return;
        setBusy(true);
        try {
            await api.post('/waitlist', { email: email.trim(), source: 'footer' });
            setDone(true);
        } catch (err) {
            toast.error(err.response?.data?.detail || 'That email didn’t look right');
        } finally { setBusy(false); }
    };
    return (
        <footer data-testid="app-footer" className="mt-auto border-t border-slate-200 bg-[#FBF7EF]/70 backdrop-blur">
            <div className="max-w-6xl mx-auto px-6 md:px-10 py-8 grid grid-cols-1 md:grid-cols-[1.2fr_1fr] gap-8 items-start">
                <div>
                    <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.24em] text-slate-500">
                        <TanowMark size={14} /> Tanow
                    </div>
                    <p className="text-sm text-slate-600 mt-2 max-w-md leading-relaxed">
                        Family care, coordinated. Designed with
                        <span className="text-slate-800 font-medium"> HIPAA-grade access controls</span> in mind —
                        compliance hardening is on the roadmap.
                    </p>
                    <div className="mt-3 flex items-center gap-1.5 text-[11px] text-slate-500">
                        <ShieldCheck size={12} weight="duotone" className="text-primary" />
                        Encrypted in transit · access limited to assigned coordinators
                    </div>
                </div>
                <div>
                    <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 mb-2">Join the waitlist</div>
                    {done ? (
                        <div data-testid="waitlist-success" className="flex items-center gap-2 text-sm text-emerald-800 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2.5">
                            <CheckCircle size={16} weight="duotone" /> You’re on the list. We’ll be in touch.
                        </div>
                    ) : (
                        <form onSubmit={submit} className="flex items-center gap-2">
                            <Input
                                type="email"
                                data-testid="waitlist-email"
                                placeholder="you@example.com"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                                className="bg-white/80"
                            />
                            <Button
                                type="submit"
                                data-testid="waitlist-submit"
                                disabled={busy}
                                className="rounded-full bg-primary text-primary-foreground shrink-0"
                            >
                                <PaperPlaneTilt size={14} className="mr-1" />
                                {busy ? 'Joining…' : 'Join'}
                            </Button>
                        </form>
                    )}
                    <div className="text-[11px] text-slate-500 mt-2">
                        We’ll only email you about Tanow. No spam, no sharing.
                    </div>
                </div>
            </div>
            <div className="border-t border-slate-200/70 py-3 text-center text-[11px] text-slate-500">
                © {new Date().getFullYear()} Tanow Health · Not for urgent medical help. In an emergency, call 911.
            </div>
        </footer>
    );
}
